import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
var energy = {
  path: '/energy',
  redirect: '/energy',
  component: RootLayout,
  children: [{
    path: '/energy',
    name: 'Energy',
    component: function component() {
      return import('@/views/energy');
    },
    meta: {
      title: '能量中心'
    }
  }, {
    path: 'shop',
    name: 'EnergyShop',
    component: function component() {
      return import('@/views/energy/shop.vue');
    },
    meta: {
      title: '商品详情'
    }
  }, {
    path: 'detail',
    name: 'EnergyDetail',
    component: function component() {
      return import('@/views/energy/detail.vue');
    },
    meta: {
      title: '能量明细'
    }
  }]
};
export default energy;